import { HttpVerbsEnum } from '../../shared/enums/http-verbs.enum';
import { UserEventActionTypeEnum } from '../enum/action-type.enum';
import { EventResourceTypeEnum } from '../enum/event-resource-type.enum';
import { EventApiModel } from './event.api.model';

export class UserEventModel {
    date?: Date;
    accountId?: number;
    userId?: number;

    resourceId?: number;
    resourceType?: EventResourceTypeEnum;
    action?: UserEventActionTypeEnum;
    resourceName?: string;

    constructor(eventApiModel?: EventApiModel) {
        if (eventApiModel) {
            this.date = new Date(eventApiModel.date);
            this.accountId = eventApiModel.accountId;
            this.userId = eventApiModel.userId;
            this.resourceId = eventApiModel.resourceId;
            this.resourceType = eventApiModel.resourceType;
            if (eventApiModel.action === HttpVerbsEnum.DELETE) {
                this.action = UserEventActionTypeEnum.DELETE;
                try {
                    this.resourceName = JSON.parse(eventApiModel.details).name;
                } catch {
                    // Bad data may contain in B.E, and it may be just a string instead a JSON
                    this.resourceName = eventApiModel.details;
                }
            } else {
                this.action = JSON.parse(eventApiModel.details).action;
            }
        }
    }
}
